import investorPortalClient from './clients/investorPortal';

export const fetchDistributionsData = () =>
  investorPortalClient.get('/aggregations/distributions');
